export default __webpack_public_path__ + "static/media/ocsb_Da5_icon_a4.8906aa6b.png";